import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { Fragment as o } from "react";
import { A as d } from "../../index-CMRcNyvZ.js";
import { cn as a } from "../../utils/cn.js";
const n = ({ steps: i }) => /* @__PURE__ */ e("div", { className: "flex flex-row justify-between relative gap-2", children: i.map((r, l) => /* @__PURE__ */ t(o, { children: [
  /* @__PURE__ */ e("div", { className: "flex gap-1 text-white relative -top-5", children: /* @__PURE__ */ t(
    "div",
    {
      className: a(
        "flex gap-2 p-2 px-4",
        r.active ? "glass-tile" : ""
      ),
      children: [
        r.completed && /* @__PURE__ */ e("div", { className: "border-white border-solid border rounded-full p-1", children: /* @__PURE__ */ e(d, {}) }),
        /* @__PURE__ */ e("div", { children: r.title })
      ]
    }
  ) }),
  l !== i.length - 1 && /* @__PURE__ */ e(
    "div",
    {
      className: a(
        "flex-1 h-0.5 bg-white/50",
        r.active ? "bg-white" : ""
      )
    }
  )
] }, l)) });
export {
  n as ProgressStepper
};
